/**
 * TokenCounter — Displays user's token balance in the top bar
 *
 * Matches Figma mockup: circular badge with chain-link icon and token count.
 * Tappable — navigates to /wallet.
 */

import { useNavigate } from 'react-router-dom';
import { cn } from '@ownyou/ui-design-system';

export interface TokenCounterProps {
  count?: number;
  className?: string;
}

function ChainIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M3.9 12C3.9 10.29 5.29 8.9 7 8.9H11V7H7C4.24 7 2 9.24 2 12C2 14.76 4.24 17 7 17H11V15.1H7C5.29 15.1 3.9 13.71 3.9 12ZM8 13H16V11H8V13ZM17 7H13V8.9H17C18.71 8.9 20.1 10.29 20.1 12C20.1 13.71 18.71 15.1 17 15.1H13V17H17C19.76 17 22 14.76 22 12C22 9.24 19.76 7 17 7Z" />
    </svg>
  );
}

export function TokenCounter({ count = 1000, className }: TokenCounterProps) {
  const navigate = useNavigate();

  return (
    <button
      type="button"
      data-testid="token-counter"
      onClick={() => navigate('/wallet')}
      className={cn(
        'flex items-center gap-1 px-2.5 py-1 rounded-full',
        'border border-slate-600 bg-slate-800',
        'text-sm font-medium text-slate-200',
        'hover:bg-slate-700 transition-colors',
        'focus:outline-none focus-visible:ring-2 focus-visible:ring-sky-400',
        className,
      )}
      aria-label={`${count} tokens. Go to wallet.`}
    >
      <ChainIcon className="w-4 h-4 text-sky-400" />
      <span>{count.toLocaleString()}</span>
    </button>
  );
}
